import { reformatBlockedReason } from '~/domain/services/imageService';
import type {
    ReformatBlockedReason,
    ReformatTarget,
} from '~/domain/services/imageService';
import type { AvailableImage } from '~/hooks/image/usePrimaryImage';
import { useImageStreamProgress } from '~/hooks/image/useImageStreamProgress';

/**
 * The reformat target an available image maps to, or null when it carries
 * no readable source (a session image that has not been downloaded).
 */
export function reformatTargetFor(
    image: AvailableImage
): ReformatTarget | null {
    if (image.rawSeries) {
        return { kind: 'rawSeries', series: image.rawSeries };
    }
    if (image.imageObject) {
        return { kind: 'loadedImage', image: image.imageObject };
    }
    return null;
}

/**
 * Why a reformat of `image` is refused, or null when nothing refuses it.
 * A progressively loaded volume fills in place, so the hook follows the
 * image's stream progress: the reason lifts when the last slice arrives.
 */
export function useReformatBlockedReason(
    image: AvailableImage
): ReformatBlockedReason | null {
    useImageStreamProgress(image.imageObject);
    const target = reformatTargetFor(image);
    return target ? reformatBlockedReason(target) : null;
}
